import React from 'react';
//import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//import { FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
//import { FontawesomeObject } from '@fortawesome/fontawesome-svg-core';
import { faGithub } from '@fortawesome/free-brands-svg-icons';
import { Link } from 'react-router-dom';
//import PropTypes from 'prop-types';
const Navbar = (props) => {
  return (
    <>
      <FontAwesomeIcon icon={faGithub} />
      {/* <FontAwesomeIcon icon={} /> */}
      {/* <FontAwesomeIcon icon={} */}
      {/* <FontAwesomeIcon icon={faYinYang} /> */}
      <Link to='/'>Home</Link>
      <Link to='/about'>About</Link>
      <div>{props.title}</div>
    </>
  );
};

export default Navbar;
